const M = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUgMS4xNVY5aDUuMDhMOSAyMi44NVYxNUgzLjkyTDE1IDEuMTV6bS0yIDUuN0w4LjA4IDEzSDExdjQuMTVMMTUuOTIgMTFIMTNWNi44NXoiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPgo=";
export {
  M as default
};
//# sourceMappingURL=on-5c9e0c64.mjs.map
